import { createSelector } from "@reduxjs/toolkit";
import { selectSelfBookmark } from "./self.selector";

export const getBookmarkState = createSelector(
    selectSelfBookmark,
    (state) => state
)